import {
    checkbox, inputWrapper,
} from './styles/CheckboxView'
import {
    styledLabel,
    styledSmall,
} from '../Form/styles/FormView'
import {CheckboxProps} from './types'
import {NinchatCheckIconSolid} from 'components/Icon'
import React from 'react'

import {styled} from '../../stitches/config'

const StyledCheckbox = styled('div', checkbox)
const StyledLabels = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '10px',
    marginTop: '2px',
})
const StyledDescription = styled('small', styledSmall, {color: '$checkboxDescription'})
const StyledLabel = styled('label', styledLabel, {marginTop: 0})
const StyledInputWrapper = styled('div', inputWrapper)

const CheckboxView = React.forwardRef<HTMLInputElement, CheckboxProps>((props, _ref): React.ReactElement => {
    const {id} = props

    const {
        description,
        label,
        ...componentProps
    } = props

    const labelId = `label-${id}`
    const labelBy = `${labelId}`

    const descriptionId = `description-${id}`
    const descriptionBy = `${descriptionId}`
    const showLabels = !!label || !!description

    return (
        <StyledCheckbox>
            <div>
                <StyledInputWrapper>
                    <input
                        {...componentProps}
                        aria-labelledby={`${labelBy} ${description ? descriptionBy : ''}`}
                        ref={_ref}
                        type='checkbox'
                    />
                    <NinchatCheckIconSolid size={18} />
                </StyledInputWrapper>
            </div>
            {showLabels ?
                <StyledLabels>
                    {!!label &&
                    <StyledLabel htmlFor={id} id={labelId}>{label}</StyledLabel>}
                    {!!description &&
                    <StyledDescription id={descriptionId}>{description}</StyledDescription>}
                </StyledLabels>
                : null}
        </StyledCheckbox>)
})

CheckboxView.displayName = 'CheckboxView'

CheckboxView.defaultProps = {label: undefined}

export default CheckboxView
